import { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withStyles } from "@mui/styles";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import "./SiteMonitoringStructureBloc.css";
import IconButton from "@mui/material/IconButton";
import AddIcon from "@mui/icons-material/Add";
import { blocHasChanged } from "../../redux/siteMonitoring/siteMonitoringActions";
import { getCurrentFunctionName } from "../../performanceModeManager";
import TextFieldWithTypingTimeout from "../Input/TextFieldWithTypingTimeout";
import { clone } from "../../utils";
import { saveLot, deleteLot } from "../../redux/siteMonitoring/lotActions";
import DeleteIcon from "@mui/icons-material/Delete";

const styles = (theme) => ({
	root: {
		width: "100%",
	},
	heading: {
		fontSize: theme.typography.pxToRem(15),
		flexBasis: "33.33%",
		flexShrink: 0,
	},
	italic: {
		fontSize: theme.typography.pxToRem(13),
		flexBasis: "33.33%",
		flexShrink: 0,
		fontStyle: "italic",
		paddingTop: 0,
	},
	secondaryHeading: {
		fontSize: theme.typography.pxToRem(15),
		color: theme.palette.text.secondary,
	},
	AccordionSummaryContent: {
		content: {
			margin: 3,
		},
	},
});

class SiteMonitoringStructureBloc extends Component {
	constructor(props) {
		super(props);

		this.state = {
			expanded: this.props.expanded === this.props.currentBlocId,
		};
	}

	static getDerivedStateFromProps(nextProps, prevState) {
		if (nextProps.creationBloc) return prevState;

		let expanded = nextProps.expanded === nextProps.currentBlocId;

		if (prevState.expanded === expanded) return prevState;

		return {
			expanded,
		};
	}

	shouldComponentUpdate(nextProps, nextState) {
		if (nextProps.creationBloc) return false;

		if (
			(nextProps.expanded === nextProps.currentBlocId) !==
			this.state.expanded
		)
			return true;

		if (this.props.validated !== nextProps.validated) return true;

		if (this.props.currentBlocId !== nextProps.currentBlocId) return true;

		if (!nextState.expanded) return false;

		let nextBlocValues = nextProps.lot;
		let actualBlocValues = this.props.lot;

		if (!nextBlocValues || !actualBlocValues) {
			console.error("Valeurs introuvables");
			return null;
		}

		try {
			return blocHasChanged(nextBlocValues, actualBlocValues);
		} catch (err) {
			return true;
		}
	}

	onBlocHeaderClick = () => {
		if (!this.props.creationBloc) {
			this.props.onClick(this.props.currentBlocId);
		} else if (!this.props.disabled) {
			this.props.addLot(false);
		}
	};

	validateBloc() {}

	getBlocClasses() {
		let classes = "";

		if (this.props.expanded === this.props.currentBlocId)
			classes = classes.concat("expanded-bloc");

		return classes;
	}

	getClasses() {
		let classes = "bloc-header without-side-padding";

		if (this.props.expanded === this.props.currentBlocId)
			classes = classes.concat(" expanded-bloc");

		if (this.props.creationBloc) return classes;

		if (this.props.lot.validated) classes = classes.concat(" ok-bloc");

		return classes;
	}

	deleteLot() {
		this.props.deleteLot(
			this.props.siteMonitoring,
			this.props.lot,
			this.props.activeUser
		);
	}

	nameChange(value) {
		let clonedLot = clone(this.props.lot);
		clonedLot.name = value;
		this.props.saveLot(
			this.props.siteMonitoring,
			clonedLot,
			this.props.activeUser,
			true
		);
	}

	descriptionChange(value) {
		let clonedLot = clone(this.props.lot);
		clonedLot.description = value;
		this.props.saveLot(
			this.props.siteMonitoring,
			clonedLot,
			this.props.activeUser,
			true
		);
	}

	render() {
		console.perfLog(getCurrentFunctionName());

		const { classes } = this.props;
		let blocSubTitle = "";
		let lot = this.props.lot;

		if (!this.props.creationBloc && this.props.expanded) {
			if (!lot) {
				console.error("Valeurs introuvables");
				return null;
			}
		}

		let expandedElement = null;

		if (this.props.expanded !== this.props.currentBlocId)
			expandedElement = (
				<IconButton
					color="inherit"
					onClick={this.onBlocHeaderClick.bind(this)}
					aria-label="Étendre"
				>
					<ExpandMoreIcon />
				</IconButton>
			);
		else
			expandedElement = (
				<IconButton
					color="inherit"
					onClick={this.onBlocHeaderClick.bind(this)}
					aria-label="Réduire"
				>
					<ExpandLessIcon />
				</IconButton>
			);

		return (
			<div
				className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding"
				ref={(panel) => (this.panel = panel)}
			>
				<Accordion
					expanded={!this.props.creationBloc && this.state.expanded}
					className={this.getBlocClasses()}
				>
					<AccordionSummary
						className={this.getClasses()}
						classes={{ content: classes.AccordionSummaryContent.content }}
					>
						{this.props.creationBloc ? (
							<IconButton
								className="padding-add-btn"
								color="inherit"
								onClick={this.onBlocHeaderClick.bind(this)}
								disabled={this.props.disabled}
								aria-label="Ajouter"
							>
								<AddIcon />
							</IconButton>
						) : (
							<div className="row without-side-padding without-margin">
								<div className="without-side-padding col-lg-2 col-md-2 col-sm-2 col-2">
									{expandedElement}
								</div>
								<div
									className="col-lg-8 col-md-8 col-sm-8 col-8 without-side-padding"
									onClick={this.onBlocHeaderClick.bind(this)}
								>
									<Typography className={classes.heading}>
										{lot.name}
									</Typography>
								</div>
								{this.props.notes.filter((n) => n.lot_id === lot.id).length <=
									0 && !this.props.disabled ? (
									<div className="col-lg-2 col-md-2 col-sm-2 col-2 without-side-padding">
										<IconButton
											color="inherit"
											aria-label="Supprimer"
											onClick={this.deleteLot.bind(this)}
										>
											<DeleteIcon className="red-icon" />
										</IconButton>
									</div>
								) : null}
								<div className="without-side-padding offset-lg-2 col-lg-10 offset-md-2 col-md-10 offset-sm-2 col-sm-10 offset-2 col-10">
									<Typography className={classes.italic}>
										{blocSubTitle}
									</Typography>
								</div>
							</div>
						)}
					</AccordionSummary>
					{!this.props.creationBloc ? (
						<AccordionDetails className="site-monitoring-panel-details">
							<div className="col-lg-12 col-md-12 col-sm-12 col-12 row">
								<div className="col-lg-6 col-md-6 col-sm-12 col-12">
									<TextFieldWithTypingTimeout
										value={this.props.lot.name}
										id={this.props.lot.id + "-name"}
										label="Nom"
										className="full_size control-margin-top"
										disabled={this.props.disabled}
										onValueChange={this.nameChange.bind(this)}
									/>
								</div>
								<div className="col-lg-6 col-md-6 col-sm-12 col-12">
									<TextFieldWithTypingTimeout
										value={this.props.lot.description}
										id={this.props.lot.id + "-description"}
										label="Description"
										className="full_size control-margin-top"
										disabled={this.props.disabled}
										onValueChange={this.descriptionChange.bind(this)}
									/>
								</div>
							</div>
						</AccordionDetails>
					) : null}
				</Accordion>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		notes: state.notes.notes,
		siteMonitoring: state.siteMonitoring.currentSiteMonitoring,
		activeUser: state.activeUser,
		expanded: state.siteMonitoring.expandedLotId,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		saveLot: (siteMonitoring, lot, user, withoutLoader) =>
			dispatch(saveLot(siteMonitoring, lot, user, withoutLoader)),
		deleteLot: (siteMonitoring, lot, user) =>
			dispatch(deleteLot(siteMonitoring, lot, user)),
	};
};

export default compose(
	withStyles(styles),
	connect(mapStateToProps, mapDispatchToProps)
)(SiteMonitoringStructureBloc);
